function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  id: "Rectangle_5600",
  "data-name": "Rectangle 5600",
  width: 48,
  height: 48,
  opacity: 0
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "Subtraction_8",
  "data-name": "Subtraction 8",
  d: "M16845.92,278.977a23.448,23.448,0,0,1-9.277-1.906,24.474,24.474,0,0,1-12.811-12.808,23.541,23.541,0,0,1,0-18.56,24.41,24.41,0,0,1,12.795-12.8,23.6,23.6,0,0,1,18.568,0,24.442,24.442,0,0,1,12.822,12.8,23.541,23.541,0,0,1,0,18.56,24.461,24.461,0,0,1-12.809,12.808A23.491,23.491,0,0,1,16845.92,278.977Zm-9.293-24.34a1.882,1.882,0,0,0-1.879,1.926,2.519,2.519,0,0,0,.563,1.528l5.906,7.244a2.463,2.463,0,0,0,2.07,1.152,2.284,2.284,0,0,0,1.977-1.152l11.059-17.405a3.38,3.38,0,0,0,.59-1.55,1.9,1.9,0,0,0-2-1.812,2.048,2.048,0,0,0-1.668,1.084l-10.047,16.131-4.779-6.16A2.027,2.027,0,0,0,16836.627,254.637Z",
  transform: "translate(-16821.922 -231)",
  fill: "#0bc628"
});

var SvgCheckmarkcircle = function SvgCheckmarkcircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "checkmark.circle.fill",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCheckmarkcircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checkmark.circle.67e7c384.svg";
export { ForwardRef as ReactComponent };